import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sumologic/yama-ds-components';
import { withRouter } from 'react-router-dom';

import Translate from '~/components/Translate/Translate';
import BlankSpacePlaceholder from '~/components/BlankSpacePlaceholder/BlankSpacePlaceholder';

import Lottie from '~/containers/Lottie/Lottie';
import permissionDenied from '~/public/img/animatedSVG/permissionDenied';

const AccessDenied = ({
    history,
    title,
    description,
    onClick,
    label,
    className = 'background-5',
    animationData = permissionDenied
}) => {
    const clickHandler = onClick
        ? event => {
              onClick(event, history);
          }
        : () => {
              history.goBack();
          };
    return (
        <BlankSpacePlaceholder
            className={className}
            img={
                <Lottie
                    width={300}
                    height={250}
                    options={{
                        animationData: animationData
                    }}
                />
            }
            title={title ?? <Translate message="Permission denied" />}
            description={description}
            actions={
                <Button variant="text" color="primary" onClick={clickHandler}>
                    <h5>{label ?? <Translate message="Go back" />}</h5>
                </Button>
            }
        />
    );
};

AccessDenied.propTypes = {
    history: PropTypes.any,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.node,
    onClick: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    className: PropTypes.string,
    animationData: PropTypes.object
};

export default withRouter(AccessDenied);
